import { useNavStore } from '../store/useNavStore';

/**
 * Minimum-viable aiming reticle — a 4px cream dot at screen center.
 *
 * Visible only in walk-like states (freeWalk, guidedTour) per Plan 03's
 * nav machine. Hidden during boarding / cinematic / compare flows.
 *
 * AESTHETIC-BRIEF Rule 7: period-quiet. A simple dot reads quieter than any
 * shaped reticle and honors the "no modern flat UI inside the 3D view frame"
 * rule because it's chrome-neutral.
 */
export function Crosshair() {
  const navState = useNavStore((s) => s.navState);
  if (navState !== 'freeWalk' && navState !== 'guidedTour') return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: 4,
        height: 4,
        marginLeft: -2,
        marginTop: -2,
        background: '#FDF6EE',
        opacity: 0.55,
        borderRadius: 2,
        pointerEvents: 'none',
        zIndex: 5,
      }}
      aria-hidden
    />
  );
}
